// src/components/Layout.jsx

import AIChatWidget from './AIChatWidget';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="bg-black pt-20"> {/* 7rem padding-top */}
        {children}
      </main>
      <AIChatWidget />
    </>
  );
};

export default Layout;
